import React from 'react';
import Wrapper from './styles';
import UiCloseButton from '../../../../ui/close-button/UiCloseButton';
import {
    formatMarketMatchNameForTicket,
    formatMarketName,
    getLineByResultKey,
    getTeamNameByOutcomeResultKey,
} from '../../../../../services/contests';
import { Leg } from '@staycool/contests-types/leg';

interface Props {
    selection: {
        marketId: number;
        outcomeId: number;
        matchId: number;
    };
    onRemove: () => void;
    activeLeg?: Leg;
}
export default function SportContestsBetslipSelection({ selection, onRemove, activeLeg }: Props) {
    const selectedMarket = activeLeg?.markets?.find((market) => market.market_id === selection.marketId);
    const selectedOutcome = selectedMarket?.outcomes.find((outcome) => outcome.outcome_id === selection.outcomeId);

    if (!selectedMarket || !selectedOutcome) {
        return null;
    }

    return (
        <Wrapper>
            <UiCloseButton size={30} className="selection-remove" onClick={onRemove} />
            <div className="selection">
                <div className="selection-number">{+selectedOutcome.position + 1}</div>
                <div className="selection-description">
                    <div>
                        {`${getTeamNameByOutcomeResultKey(
                            selectedOutcome.result_key,
                            selectedMarket,
                        )} ${getLineByResultKey(selectedOutcome.result_key, selectedMarket.line)}`}
                    </div>
                    <span>{formatMarketName(selectedMarket.market_name)}</span>
                    <span>{formatMarketMatchNameForTicket(selectedMarket.match_name)}</span>
                </div>
            </div>
        </Wrapper>
    );
}
